import { jwtDecode } from "jwt-decode";
import UserDataModel from "./UserDataModel";
import DC from "../../common/DataConnector";
import TokenStore from "../../common/TokenStore";
import { reducerUserLoad, reducerUserLogout, reducerUserOrderRefresh } from "./UserDataReducer";

function CheckToken(token: string) {
    if (token && token !== "") {
        try {
            const decoded: any = jwtDecode(token);
            if (Date.now() >= decoded.exp * 1000) {
                TokenStore.remove()
            }
            else
                return decoded;
        } catch (e) {
            console.log(e);
        }
        return undefined;
    }
}

export async function credentialLoad(credentials: UserDataModel, dispatch: any) {
    if (credentials.user.id && credentials.user.id !== '')
        return;

    const token = TokenStore.get();
    if (token === '') return;
    const model = CheckToken(token)
    if (model) {
        let result = await DC.Get('/customer/account', {});
        if (result.wasOk) {
            credentials = {
                token: token,
                user: { id: model.id, code: model.code, email: model.email },
                preferences: {
                    contactName: result.data.name, contactPhone: result.data.phone,
                    receivePromotions: result.data.preferences.receivePromotions,
                    receiveNews: result.data.preferences.receiveNews
                },
                invoices: [], orders: [],
                isActive: true,
                loyalty: result.data.loyalty
            };
            dispatch(reducerUserLoad(credentials));
        }
    }
}

export async function credentialClear(dispatch: any) {
    TokenStore.remove()
    dispatch(reducerUserLogout())
}

export async function credentialSave(token: string, dispatch: any) {
    await TokenStore.set(token)
    dispatch(reducerUserLoad({ token: token }))
    credentialLoad(new UserDataModel(), dispatch)
}

export async function ordersLoad(dispatch: any) {
    const token = TokenStore.get();
    if (token === '') return;
    if (!CheckToken(token)) return;

    const customerOrders = await DC.Get('/customer/orders', {});
    if (customerOrders.wasOk) {
        let ritmitosInOrders = 0
        for (let x = 0; x < customerOrders.data.length; x++) {
            ritmitosInOrders += customerOrders.data[x].ritmitosUsed
        }
        dispatch(reducerUserOrderRefresh({ orders: customerOrders.data, ritmitosInOrders: ritmitosInOrders }))
    }
}